import axios from 'axios';
import { ACCESS_TOKEN_KEY, useAuthStore } from '../stores/useAuthStore';
import { getCookie } from './cookies';

let noResponseErrorTimer = null;
const DEBOUNCE_TIME = 3000; // 3 seconds

axios.defaults.timeout = 12000; // 12 seconds

axios.interceptors.request.use(
  (config) => {
    const accessToken = getCookie(ACCESS_TOKEN_KEY);
    if (accessToken) {
      config.headers['Authorization'] = `Bearer ${accessToken}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    // Handle 401 Unauthorized
    if (
      error.response?.status === 401 &&
      error.response?.data?.error === 'Invalid or expired JWT token'
    ) {

      if (window.location.pathname !== '/login') {
        useAuthStore.getState().logout();
        window.location.replace('/login');
      }
    }
    // Handle errors with a response from server
    else if (error.response) {
      let message = '';

      if (typeof error.response?.data === 'string') {
        message = error.response.data;
      } else if (error.response?.data) {
        message = error.response.data?.message || error.response.data?.error;
      } else {
        // Fallback
        message = `Something went wrong (${error.response.status || 'unknown'})`;
      }

      if (!error.config?.skipAlert) {
        window.triggerAlert({
          title: message,
          type: 'error',
        });
      }
    }
    // Handle network errors (no response received)
    else if (error.request) {
      if (!noResponseErrorTimer && !error.config?.skipAlert) {
        window.triggerAlert({ title: 'No response received', type: 'error' });
        noResponseErrorTimer = setTimeout(() => {
          noResponseErrorTimer = null;
        }, DEBOUNCE_TIME);
      }
    }
    // Other errors in setting up the request
    else {
      console.error('Error', error.message);
    }

    return Promise.reject(error);
  }
);
